import { AutomatonContextMenuContext } from '@components/map/contextMenu/builders/sensor';
import { useAutomatonCommand } from '@hooks/useAutomatonCommand';
import {
  automatonHasOneCabinetPoweredOff,
  automatonHasOneCabinetPoweredOn,
  getAutomatonSectionStatuses,
  getDefenceState,
  isSensorOrSubSensorConfigurationOfType,
  isSensorOrSubSensorStatusOfType,
} from '@utils/sensors/sensors.utils';

import { SensorOrSubSensorConfiguration } from '@/types/sensor/configuration.types';
import {
  AutomatonSegmentStatus,
  AutomatonSensorConfiguration,
  AutomatonSensorStatus,
  SensorTypeEnum,
} from '@/types/sensor/sensors';
import { SensorOrSubSensorStatus } from '@/types/sensor/status.types';

const DEFAULT_CONTEXT: AutomatonContextMenuContext = {
  isSleepAllCommandLoading: false,
  isPowerOnCabinetsOptionDisabled: true,
  isPowerOffCabinetsOptionDisabled: true,
  isAutomatonDefenceOptionLoading: false,
  isDisableCabinetsRepulsionOptionDisabled: true,
  isDisableCabinetsRepulsionOptionHidden: true,
  isEnableCabinetsRepulsionOptionDisabled: true,
  isEnableCabinetsRepulsionOptionHidden: true,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onAutomatonSleepOptionAction: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onAutomatonDefenceOptionAction: () => {},
};

export function useAutomatonSensorContextMenu(
  configuration: SensorOrSubSensorConfiguration | null,
  status: SensorOrSubSensorStatus | AutomatonSegmentStatus | null,
): AutomatonContextMenuContext {
  const isAutomatonConfiguration = isSensorOrSubSensorConfigurationOfType(configuration, SensorTypeEnum.AUTOMATON);
  const isAutomatonStatus = isSensorOrSubSensorStatusOfType(status, SensorTypeEnum.AUTOMATON);

  const useAutomaton = useAutomatonCommand({
    automatonStatus: status as AutomatonSensorStatus | null,
    automatonConfiguration: configuration as AutomatonSensorConfiguration | null,
  });

  if (!useAutomaton.canCommand || !isAutomatonConfiguration || !isAutomatonStatus) {
    return DEFAULT_CONTEXT;
  }

  const segmentStatuses = getAutomatonSectionStatuses(status);
  const defenceState = getDefenceState(segmentStatuses);

  return {
    isSleepAllCommandLoading: useAutomaton.isSleepAllCommandLoading,
    isPowerOnCabinetsOptionDisabled: !automatonHasOneCabinetPoweredOff(status),
    isPowerOffCabinetsOptionDisabled: !automatonHasOneCabinetPoweredOn(status),
    onAutomatonSleepOptionAction: useAutomaton.sleepAll,
    isAutomatonDefenceOptionLoading: useAutomaton.isRepulsionCommandLoading,
    isDisableCabinetsRepulsionOptionDisabled: defenceState === 'detection',
    isDisableCabinetsRepulsionOptionHidden: !useAutomaton.canDetect,
    isEnableCabinetsRepulsionOptionDisabled: defenceState === 'repulsion',
    isEnableCabinetsRepulsionOptionHidden: !useAutomaton.canRepulse,
    onAutomatonDefenceOptionAction: useAutomaton.repulse,
  };
}
